import React, { memo, Fragment } from 'react';
import { CircularProgress, createStyles, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from '../../../app/i18n';

import { PopularModel } from 'src/components/typography/iconTypography';
import { AppmodelNavbarLink, NavbarLink, SidebarButtons } from './styledComponent';
import { useIsMobileSize } from 'src/hooks/useIsMobile';
import { MobileTypography } from 'src/mobile/Typography';
import clsx from 'clsx';
import { POPULAR } from 'src/components-pages/app-model/data/constants';
import { useAppModelSidebar } from 'src/components-pages/shared/services/appmodels.sidebar';
import { useAppmodelSidebarData } from 'src/components-pages/shared/appmodel.provider';

const useSidebarStyle = makeStyles((theme) =>
    createStyles({
        icon: { marginRight: 4 },
        seprator: {
            borderBottom: `solid 1px ${theme.palette.secondary.main}`,
            marginBottom: theme.spacing(2),
            width: '100%'
        },
        sepratorText: {
            width: '100%',
            color: theme.palette.secondary.main,
            textAlign: 'left'
        },
        disabledText: {
            color: theme.palette.text.disabled
        },
        progress: {
            margin: theme.spacing(2),
            alignSelf: 'center'
        }
    })
);

const useTextStyles = makeStyles({
    root: {
        fontWeight: 600,
        margin: '8px 0'
    }
});
const SemiBoldTypography = memo(({ className, ...props }: any) => {
    const classes = useTextStyles();
    const isMobileSize = useIsMobileSize();
    return isMobileSize ? (
        <MobileTypography variant="h4" className={clsx(classes.root, className)} {...props} />
    ) : (
        <Typography className={clsx(classes.root, className)} {...props} />
    );
});

export const AboutSidebar = () => {
    const { t } = useTranslation('common');

    return (
        <>
            <NavbarLink href="/about">
                <SemiBoldTypography>{t('about.aboutApsy')}</SemiBoldTypography>
            </NavbarLink>
            {/* <NavbarLink href="product">
                <SemiBoldTypography>{t('about.products')}</SemiBoldTypography>
            </NavbarLink> */}
            <NavbarLink href="/a-team">
                <SemiBoldTypography>{t('about.team')}</SemiBoldTypography>
            </NavbarLink>
            <NavbarLink href="/vision-values">
                <SemiBoldTypography>{t('about.value')}</SemiBoldTypography>
            </NavbarLink>
        </>
    );
};

export const PricingSidebar = () => {
    const { t } = useTranslation('common');
    return (
        <>
            <NavbarLink href="/pricing/make-affordable">
                <SemiBoldTypography>{t('pricing.affordable')}</SemiBoldTypography>
            </NavbarLink>
            <NavbarLink href="/pricing/make-competitive">
                <SemiBoldTypography>{t('pricing.competitive')}</SemiBoldTypography>
            </NavbarLink>
        </>
    );
};

export const AppModelsSidebar = () => {
    const classes = useSidebarStyle();
    const { t } = useTranslation('common');
    // const { categories, loading: categoriesLoading } = useGetCategories();
    const data = useAppmodelSidebarData();
    const { categories, existingCategories } = useAppModelSidebar(data);
    const loading = false;
    return (
        <>
            <AppmodelNavbarLink model={POPULAR}>
                <PopularModel text={t('model.popular')} />
            </AppmodelNavbarLink>

            {!loading ? (
                <>
                    {categories
                        ?.filter((c) => existingCategories.includes(c.categoryId))
                        ?.map((model) => (
                            <Fragment key={model.categoryId}>
                                <AppmodelNavbarLink model={model}>
                                    <SemiBoldTypography align="left">
                                        {model.name}
                                    </SemiBoldTypography>
                                </AppmodelNavbarLink>
                            </Fragment>
                        ))}
                    <SidebarButtons className={classes.seprator}>
                        <SemiBoldTypography className={classes.sepratorText}>
                            {t('model.commingSoon')}
                        </SemiBoldTypography>
                    </SidebarButtons>

                    {categories
                        ?.filter((c) => !existingCategories.includes(c.categoryId))
                        ?.map((model) => (
                            <Fragment key={model.categoryId}>
                                <SidebarButtons disabled>
                                    <SemiBoldTypography className={classes.disabledText}>
                                        {model.name}
                                    </SemiBoldTypography>
                                </SidebarButtons>
                            </Fragment>
                        ))}
                </>
            ) : (
                <CircularProgress className={classes.progress} />
            )}
            {/* {['resaurants', 'shop', 'matching', 'booking', 'fitness'].map((model) => (
                <AppmodelNavbarLink model={model}>
                    <SemiBoldTypography align="left">{t(`model.${model}`)}</SemiBoldTypography>
                </AppmodelNavbarLink>
            ))} */}
        </>
    );
};
